"use client";

import { useEffect, useRef } from "react";
import Link from "next/link";
import PrototypePlanet, {
  type PlanetMotionState,
} from "@/components/PrototypePlanet";

export default function StartConversationThankYouPage() {
  const headingRef = useRef<HTMLHeadingElement>(null);
  const motionState = useRef<PlanetMotionState>({
    preference: "auto",
    mode: "full",
    speed: 0.72,
    precision: 0,
    brandSignal: 0,
    brandSignalFocus: null,
    judgment: 0,
    judgmentFocus: null,
    outcomes: 0,
    outcomeFocus: null,
    outcomeSequence: 0,
    industries: 0,
    industryFocus: null,
    industryPreview: false,
    industrySequence: 0,
    questions: 0,
    questionCategory: null,
    questionPreview: false,
    questionSequence: 0,
    perspectives: 0,
    perspectiveFocus: null,
    contact: 0.18,
  });

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <main className="thank-you-page">
      <header className="thank-you-topbar">
        <Link className="thank-you-brand" href="/" aria-label="Return to FTO">
          <span>FTO</span><i />
        </Link>
        <p><span>Experience architecture</span><strong>Request received</strong></p>
        <Link href="/">Return to FTO <i aria-hidden="true">↗</i></Link>
      </header>

      <div className="thank-you-grid" aria-hidden="true" />
      <div className="thank-you-atmosphere" aria-hidden="true" />

      <section className="thank-you-experience" aria-labelledby="thank-you-title">
        <div className="thank-you-planet" aria-hidden="true">
          <div className="planet-aura" />
          <PrototypePlanet motionState={motionState} />
        </div>

        <article className="thank-you-copy">
          <div className="thank-you-section-label">
            <span>07</span><i /><strong>Conversation Started</strong>
          </div>
          <p className="thank-you-eyebrow">Request Received</p>
          <h1 id="thank-you-title" ref={headingRef} tabIndex={-1}>Your delivery model starts here.</h1>
          <p className="sr-only" role="status" aria-live="polite">
            Your request has been received successfully.
          </p>
          <p className="thank-you-body">
            Thank you for sharing your goals with FTO. Our team will review your
            workflow, delivery preferences, and customer experience priorities
            before reaching out.
          </p>
          <p className="thank-you-support">
            A member of our team will contact you using the information provided.
          </p>

          <div className="thank-you-sequence" aria-label="Conversation progress">
            <span data-complete="true"><i />Experience understood</span>
            <span data-complete="true"><i />Delivery needs defined</span>
            <span data-complete="true"><i />Conversation started</span>
          </div>

          <nav className="thank-you-links" aria-label="Continue exploring FTO">
            <Link href="/#solutions">Explore Our Capabilities <i aria-hidden="true">→</i></Link>
            <Link href="/#industries">View Industries <i aria-hidden="true">→</i></Link>
            <Link href="/">Return to FTO <i aria-hidden="true">→</i></Link>
          </nav>
        </article>
      </section>

      <footer className="thank-you-footer">
        <span>FTO / Experience System</span>
        <strong>Request secured in the system</strong>
      </footer>
    </main>
  );
}
